import { extractTimeComponents } from '../../parsers/timeInput/getTimeParts';
import { getSupportedTimeFormatsForLocale } from '../../parsers/timeInput/helpers/timeHelpers';
import { InkDateType, TimeResult } from '../../types';
import { isValidTime } from '../internal/temporalDate/dateBuilder';
import { extractStandardDateTimeParts } from '../internal/standardDateTime/extractStandardDateTimeParts';

type NormalizeTimeArgs = {
  value: InkDateType;
  locale;
  isStrictMode?: boolean;
};
export const normalizeTime = ({ value, locale, isStrictMode = true }: NormalizeTimeArgs): TimeResult => {
  const result = extractStandardDateTimeParts(value);
  if (result) {
    const [dateTimeParts, timeZoneSource] = result;
    const { hours, minutes, seconds, milliseconds } = dateTimeParts;
    return {
      timeParts: {
        hours,
        minutes,
        seconds,
        milliseconds,
      },
      isValidTime: true,
      input: value.toString(),
      timeZoneSource,
    };
  }
  const supportedFormats = getSupportedTimeFormatsForLocale(locale);
  const timeParts = extractTimeComponents({ value: value.toString(), supportedFormats, isStrictMode });
  return {
    timeParts: timeParts ?? { hours: -1, minutes: -1, seconds: -1, milliseconds: -1 },
    isValidTime: isValidTime(timeParts),
    input: value.toString(),
    timeZoneSource: 'local',
  };
};
